import { render, staticRenderFns } from "./ProductBindingView.vue?vue&type=template&id=16a54df2&scoped=true&"
import script from "./ProductBindingView.vue?vue&type=script&lang=js&"
export * from "./ProductBindingView.vue?vue&type=script&lang=js&"
import style0 from "./ProductBindingView.vue?vue&type=style&index=0&id=16a54df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a54df2",
  null
  
)

export default component.exports